<div class="dialog-confirm-delete-criterias-group">
  <span class="dialog-confirm-delete-criterias-group__title">
    {{ 'DIALOG_CONFIRM_DELETE_CRITERIAS_GROUP.TITLE' | translate }}
  </span>
  <span class="dialog-confirm-delete-criterias-group__content">
    {{ 'DIALOG_CONFIRM_DELETE_CRITERIAS_GROUP.CONTENT' | translate }}
  </span>
  <div class="dialog-confirm-delete-criterias-group__buttons">
    <button (click)="deleteCriteriaGroup()" class="dialog-confirm-delete-criterias-group__buttons__yes">
      {{ 'DIALOG_CONFIRM_DELETE_CRITERIAS_GROUP.BUTTONS.YES' | translate }}
    </button>
    <button (click)="matDialogRef.close()" class="dialog-confirm-delete-criterias-group__buttons__no">
      {{ 'DIALOG_CONFIRM_DELETE_CRITERIAS_GROUP.BUTTONS.NO' | translate }}
    </button>
  </div>
</div>
